import camelcaseKeys from "camelcase-keys";

import { VenueOnlineConfigSchema } from "@common/schemas/VoucherOnlineConigSchema";

import { authorizedGet } from "@onsite_app/MobileOrderingMenu/authorizedRequests";

export const fetchVenueOnlineConfig = async () => {
  const { body } = await authorizedGet({
    url: `/v1/venue_online_configs`,
  });
  return VenueOnlineConfigSchema.parse(
    camelcaseKeys(body.venue_online_config, { deep: true }),
  );
};
